import { isIPhone, isIPad, isAndroid, isAndroidTab } from "@/src/front/common";
import { FlowTask } from "@/controllers/flow";

/**
 * クラシックゲーム起動フローで共通利用する判定/タスク群。
 *
 * - 端末種別（SP/TB）判定
 * - DOMの表示切り替え
 * - ROM URL の期限切れ対策（再読込）
 */

// ヘルパー

/**
 * SP（スマホ）判定。
 * @returns {boolean}
 */
export function isSP() {
  return isIPhone || isAndroid;
}

/**
 * TB（タブレット）判定。
 * @returns {boolean}
 */
export function isTB() {
  return isIPad || isAndroidTab;
}

// フロー

/**
 * 画面初期状態を作るタスク。
 * - SP/TB はサムネ領域に専用クラス付与
 * - プレイ画面/コントローラ等は一旦非表示
 */
export class InitializeTask extends FlowTask {
  constructor() {
    super();
    this.playThumnailContainer = $("#play-thumnail");
    this.playScreenContainer = $("#play-screen");
    this.playControllerContainer = $("#play-controller");
    this.playSideNavControllerContainer = $("#play-side-nav-controller");
    this.playSideNavManualContainer = $("#play-side-nav-manual");
  }

  async flowProcess(done) {
    if (isSP()) {
      this.playThumnailContainer.addClass("js-only-sp");
    }
    if (isTB()) {
      this.playThumnailContainer.addClass("js-only-tb");
    }

    this.playScreenContainer.hide();
    this.playControllerContainer.hide();
    this.playSideNavControllerContainer.hide();
    if (!isSP() && !isTB()) this.playSideNavManualContainer.hide();
    done();
  }
}

/**
 * 再生ボタンが押されるまで待つタスク（once）。
 */
export class PlayButtonTask extends FlowTask {
  async flowProcess(done) {
    document.querySelector("#play-button").addEventListener("click", () => {
      done();
    }, {
      "once": true
    });
  }
}

/**
 * ゲーム本体を起動するタスク。
 * - サムネ等を非表示にしてプレイUIを表示
 * - ROM URL が期限切れなら同ページHTMLを再取得して差し替え
 * - `#emu_url` から得たスクリプトを `#game-loader` へ挿入
 */
export class StartGameTask extends FlowTask {
  constructor() {
    super();
    this.playThumnailContainer = $("#play-thumnail");
    this.playScreenContainer = $("#play-screen");
    this.playControllerContainer = $("#play-controller");
    this.playSideNavControllerContainer = $("#play-side-nav-controller");
    this.playSideNavManualContainer = $("#play-side-nav-manual");

    const gameLoaderContainer = document.querySelector("#game-loader");
    if (gameLoaderContainer) {
      const emuURLElement = gameLoaderContainer.querySelector("#emu_url");
      this.emuUrl = emuURLElement.value;
      emuURLElement.remove();
    }
  }

  async flowProcess(done) {
    document.querySelector("#play-button").remove();

    this.playThumnailContainer.hide();
    this.playScreenContainer.show();
    this.playControllerContainer.show();
    this.playSideNavControllerContainer.show();
    this.playSideNavManualContainer.show();

    if (this.checkRomExpiration()) await this.reloadRom();

    const gameLoaderContainer = document.querySelector("#game-loader");
    const emuScriptElement = document.createElement("script");
    emuScriptElement.src = this.emuUrl;

    gameLoaderContainer.appendChild(emuScriptElement);

    $(window).scrollTop(0);
    done();
  }

  checkRomExpiration() {
    const romUrl = document.querySelector("#rom_url").value;
    const urlObj = new URL(romUrl, window.location.origin);
    const expires = urlObj.searchParams.get("Expires");
    const expiresTimestamp = parseInt(expires);
    const currentTimestamp = Math.floor(Date.now() / 1000);
    return expiresTimestamp < currentTimestamp;
  }

  async reloadRom() {
    const currentUrl = window.location.href;
    const response = await fetch(currentUrl, {
      method: "GET",
      headers: {
        "Accept": "text/html",
        "Content-Type": "text/html",
        "User-Agent": navigator.userAgent,
      }
    });
    const htmlText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    const newRomURL = doc.querySelector("#rom_url").value;
    const romURLElement = document.querySelector("#rom_url");
    romURLElement.value = newRomURL;
  }
}

/**
 * SP/TB の場合に別ページへ遷移するタスク。
 */
export class ToSPPageTask extends FlowTask {
  constructor(redirectPathValue) {
    super();
    this.redirectPathValue = redirectPathValue;
  }

  async flowProcess(done) {
    window.location.href = this.redirectPathValue;
    done();
  }
}
